import * as React from 'react'
import { FC } from 'react'
import Accordion, { AccordionHeaderProps } from '@organisms/Accordion'
import { ListItemProps } from '@templates/List'
import { RiskMapJobPosition } from '@models/riskMapJobPosition'
import InfoField from '@organisms/InfoField'
import Title from '@organisms/Title'
import Body from './Body'
import { Container, Row, Wrapper } from './styled'
import CopyPositionAndDangers from './CopyPositionAndDangers'

const PositionAndDanger: FC<ListItemProps<RiskMapJobPosition>> = ({
  isLoading,
  handleClickOnItem,
  opened,
  item: { title, id, dangersCount },
}) => {
  const header: FC<AccordionHeaderProps> = () => {
    return (
      <Container>
        <Wrapper>
          <Row>
            <Title mySize="h4">{title}</Title>
          </Row>
          <Row>
            <InfoField label="Количество опасностей" value={dangersCount} />
          </Row>
        </Wrapper>
        <CopyPositionAndDangers positionAndDangersId={id} />
      </Container>
    )
  }

  return (
    <Accordion
      skeletonHeight={180}
      handleClickOnHeader={handleClickOnItem}
      expanded={opened}
      initLoading={isLoading}
      Header={header}
      Body={({ onChangeSize, toggleLoading }) => (
        <Body
          onChangeSize={onChangeSize}
          toggleLoading={toggleLoading}
          id={id}
        />
      )}
    />
  )
}

export default PositionAndDanger
